import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import { styled } from '@mui/material/styles';

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: '100%',
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: 2,
  marginTop: 12,
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  width: '100%',
  backgroundColor: theme.palette.grey[50],
  borderRadius: 2,
}));

export const StyledHeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  position: 'relative',
  '&:not(:last-of-type)::after': {
    content: '""',
    position: 'absolute',
    top: '37.5%',
    bottom: '37.5%',
    right: 0,
    width: 2,
    backgroundColor: theme.palette.grey[300],
    borderRadius: 2,
  },
}));
